const { getElement, getElements } = window.BAO.Utils
const preBuyUtils = new window.PreBuyUtils()

export class ProductForm extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    await this.checkPreBuy()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  async checkPreBuy () {
    if (this.dataset.checkPreBuy === undefined) return

    const productId = this.dataset.productId
    const variantId = this.dataset.variantId

    if (!productId || !variantId) return

    const preBuyData = await preBuyUtils.getPreBuyData(productId, variantId)
    const legacyPreOrder = getElement(
      `[data-pre-order="true"][data-variant-id="${variantId}"]`,
    )

    if (!legacyPreOrder && preBuyData?.enabled && preBuyData?.variantPool) {
      const sellingPlanId =
        preBuyData?.variantPool?.sellingPlanId?.replace(
          'gid://shopify/SellingPlan/',
          '',
        ) || ''

      // Add the data-pre-order attribute to the button
      const addToCartButton = this.querySelector('[data-product-add-to-cart]')
      if (addToCartButton) {
        addToCartButton.setAttribute('data-pre-order', 'true')
        addToCartButton.setAttribute('data-variant-id', variantId)
      }

      const buttonText = getElements(`[data-product-add-to-cart-text]`)
      buttonText.forEach(el => {
        el.innerText = window.variantStrings.preOrder
      })

      const estimatedDispatchText = document.querySelectorAll(
        '[data-product-estimated-dispatch-text]',
      )
      estimatedDispatchText.forEach(el => {
        el.innerHTML = preBuyData?.variantPool?.estDispatchDateFormatted || ''
        el.removeAttribute('aria-hidden')
      })

      const estimatedDispatch = document.querySelectorAll(
        '[data-product-estimated-dispatch]',
      )
      estimatedDispatch.forEach(el => {
        el.removeAttribute('aria-hidden')
      })

      const propertiesEl = this.querySelector('[data-properties]')
      if (propertiesEl) {
        const date = new Date(preBuyData?.variantPool?.estDispatchDate)
        const month = date.getMonth() + 1
        const dateFormatted = `${String(month).padStart(2, '0')}/${String(
          date.getDate(),
        ).padStart(2, '0')}/${date.getFullYear()}`

        propertiesEl.innerHTML = `
          <input type="hidden" name="properties[_preorder]" value="true">
          <input type="hidden" name="properties[${
            window.theme.strings.estimated_dispatch
          }]" value="${preBuyData?.variantPool?.estDispatchDateFormatted}">
          <input type="hidden" name="properties[_pool_location]" value="${
            preBuyData?.variantPool?.location
          }">
                    <input type="hidden" name="properties[_dispatch_date]" value="${
                      preBuyData.variantPool.estDispatchDate
                    }">
          <input type="hidden" name="properties[_start_date]" value="${dateFormatted}">
          <input type="hidden" name="selling_plan" value="${
            sellingPlanId ? parseInt(sellingPlanId, 10) : null
          }">
        `
      }

      document.documentElement.style.setProperty(
        '--ProductDetail_Height_extra',
        '25px',
      )
    } else if (
      !legacyPreOrder &&
      preBuyData?.enabled &&
      !preBuyData?.variantPool &&
      preBuyData.currentlyNotInStock
    ) {
      const buttonText = getElements(`[data-product-add-to-cart-text]`)
      buttonText.forEach(el => {
        el.innerText = window.variantStrings.soldOut
      })

      const addToCartButton = getElements(`[data-product-add-to-cart]`)
      addToCartButton.forEach(el => {
        el.disabled = true
      })
    } else {
      document.documentElement.style.setProperty(
        '--ProductDetail_Height_extra',
        '0px',
      )
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    this.toggleButtonText()
    await this.addToCart()
  }

  async addToCart () {
    try {
      await window.BAO.Cart.addItemFromForm(this.form)
    } catch (error) {
      console.error('Error adding item to cart:', error)
    }
  }

  toggleButtonText () {
    const buttonText = this.querySelector('[data-product-add-to-cart-text]')
    const addToCartButton = this.querySelector('[data-product-add-to-cart]')

    if (
      !buttonText ||
      !window.variantStrings.addToCart ||
      !window.variantStrings.added
    ) {
      return
    }

    const isPreOrder = addToCartButton?.dataset?.preOrder === 'true'

    buttonText.innerText = window.variantStrings.added

    window.setTimeout(() => {
      buttonText.innerText = isPreOrder
        ? window.variantStrings.preOrder
        : window.variantStrings.addToCart
    }, 3000)
  }

  get id () {
    const formData = new FormData(this.form)

    return formData.get('id')
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
